import { NativeDataFetcher } from "@sitecore-jss/sitecore-jss-nextjs";
import { PlacesResponse, NearbySearchArgs } from "../../types/google-types";

export const placesNearbySearch = async (
  lat: number,
  lng: number,
  args: NearbySearchArgs
): Promise<PlacesResponse | null> => {
  const fetcher = new NativeDataFetcher({
    headers: [
      ["Content-Type", "application/json"],
      ["Referer", args.referer],
      [
        "X-Goog-Api-Key",
        process.env.NEXT_PUBLIC_GoogleApiKey as string,
      ],
      [
        "X-Goog-FieldMask",
        "places.id,places.formattedAddress,places.location.latitude,places.location.longitude,places.displayName.text,places.primaryTypeDisplayName.text,places.primaryType",
      ],
    ],
  });

  const data = {
    includedTypes: args.includedTypes,
    excludedTypes: args.excludedTypes,
    excludedPrimaryTypes: args.excludedPrimaryTypes,
    maxResultCount: args.maxResultCount,
    rankPreference:
      args.rankPreference,
    locationRestriction: {
      circle: {
        center: {
          latitude: lat,
          longitude: lng,
        },
        radius: args.radius,
      },
    },
  };

  return await fetcher
    .post<PlacesResponse>(
      "https://places.googleapis.com/v1/places:searchNearby",
      data
    )
    .then((response) => {
      const responseData = response.data;

      return responseData;
    })
    .catch((e) => {
      console.log(e);
      return null;
    });
};
